module.exports = __webpack_public_path__ + "media/images/admin/icons/delete-883a245452e8cd70f3404f13ebeaaeac.svg";